import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isObject from 'lodash/isObject';
import _omit from 'lodash/omit';

export function isImageUrlEmpty(image) {
  if (_isObject(image) && !_isNil(image)) {
    return _isEmpty(image?.url);
  }
  return _isEmpty(image);
}

export function cleanExtraData(extraDataValue) {
  return {
    ...extraDataValue,
    attributes: _get(extraDataValue, 'attributes', []).map((attribute) =>
      _omit(attribute, ['localId']),
    ),
  };
}
